import React from "react";

var LinkListApp = function LinkListApp(_ref) {
  var data = _ref.data,
      onHandleClick = _ref.onHandleClick;
  var links = data || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", null, links.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      className: "Link ".concat(window.location.href === item.link.href && onHandleClick ? "active-bold" : ""),
      href: item.link.href,
      onClick: function onClick() {
        return onHandleClick(data);
      },
      target: item.link.target
    }, item.link.textContent));
  })));
};

export default LinkListApp;